export default({
    documentForRoutesCount: 0,
    routesInProgressCount: 0,
    routesAlmostOverdueCount:0,
    categorySelectedCount: 0
})